<div class="db-main-header-content">
  <a class="header-title">
    <img src="assets/images/logos/10web_name_logo_dark-new.svg"
         (click)="navigateToLogin()"
         alt="10web"/>
  </a>
</div>
<main>
  <div class="user-deleted-container">
    <div class="user-deleted-title"
         [innerHTML]="'text_accountDeletedTitle' | dbText">
    </div>
    <div class="user-deleted-subtitle">
      <span [innerHTML]="'text_accountDeletedSubtitle' | dbText"></span>
      <img src="assets/images/emojis/sad.png" alt="sad emoji">
    </div>
    <div class="user-deleted-info">
      <i class="db-icon db-icon-ds-info-bg warn mr8"></i>
      <div [innerHTML]="'text_accountDeletedInfo' | dbText"></div>
    </div>
  </div>
</main>


